import _classCallCheck from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _createClass from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _inherits from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module font/fontsize/fontsizeediting
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import FontSizeCommand from "./fontsizecommand";
import { normalizeOptions } from "./utils";
import { buildDefinition, FONT_SIZE } from "../utils";
/**
 * The font size editing feature.
 *
 * It introduces the {@link module:font/fontsize/fontsizecommand~FontSizeCommand command} and the `fontSize`
 * attribute in the {@link module:engine/model/model~Model model} which renders in the {@link module:engine/view/view view}
 * as a `<span>` element with either:
 * * a style attribute (`<span style="font-size:12px">...</span>`),
 * * or a class attribute (`<span class="text-small">...</span>`)
 *
 * depending on the {@link module:font/fontsize~FontSizeConfig configuration}.
 *
 * @extends module:core/plugin~Plugin
 */

var FontSizeEditing =
/*#__PURE__*/
function (_Plugin) {
  _inherits(FontSizeEditing, _Plugin);

  _createClass(FontSizeEditing, null, [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'FontSizeEditing';
    }
    /**
     * @inheritDoc
     */

  }]);

  function FontSizeEditing(editor) {
    var _this;

    _classCallCheck(this, FontSizeEditing);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FontSizeEditing).call(this, editor)); // Define default configuration using named presets.

    editor.config.define(FONT_SIZE, {
      options: ['tiny', 'small', 'default', 'big', 'huge']
    }); // Define view to model conversion.

    var options = normalizeOptions(_this.editor.config.get('fontSize.options')).filter(function (item) {
      return item.model;
    });
    var definition = buildDefinition(FONT_SIZE, options); // Set-up the two-way conversion.

    editor.conversion.attributeToElement(definition); // Add FontSize command.

    editor.commands.add(FONT_SIZE, new FontSizeCommand(editor));
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(FontSizeEditing, [{
    key: "init",
    value: function init() {
      var editor = this.editor; // Allow fontSize attribute on text nodes.

      editor.model.schema.extend('$text', {
        allowAttributes: FONT_SIZE
      });
      editor.model.schema.setAttributeProperties(FONT_SIZE, {
        isFormatting: true,
        copyOnEnter: true
      });
    }
  }]);

  return FontSizeEditing;
}(Plugin);

export { FontSizeEditing as default };